// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const Email = t.struct({
    canMarket: t.Boolean,
    communicationLocatorId: t.Number,
    emailAddress: t.String,
    emailNotAvailableCheckSelected: t.Boolean,
    showEmailNotAvailableCheck: t.Boolean
}, {
    defaultProps: {
        canMarket: true,
        communicationLocatorId: 0,
        emailAddress: '',
        emailNotAvailableCheckSelected: false,
        showEmailNotAvailableCheck: false
    },
    name: 'Email',
    strict: true
});
